// Merges changed calls (from GET /api/ivr-calls?view=list&since=...) into the
// current `calls` array: a changed call replaces its old copy, a new call is
// added, and the result stays newest-first (id DESC, same order the server
// returns — see getAllCalls/server/callSync.js). Never mutates `previous`.
// Keyed on `id`, the calls table's primary key, which every row has (uuid
// can in principle be missing).
export const mergeCalls = (previous, changed) => {
  if (!changed.length) return previous;
  const changedIds = new Set(changed.map((call) => call.id));
  const merged = [...changed, ...previous.filter((call) => !changedIds.has(call.id))];
  merged.sort((a, b) => b.id - a.id);
  return merged;
};
